const AiContentGeneratorIntegration = () => {
  return (
    <>
      <div className="ail-integration-area pt-60 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-6 col-xl-7 col-lg-10">
              <div className="text-center mb-40">
                <p className="ail-sub-title text-black fw-500 ah-input-bg d-inline-flex align-items-center gap-2 rounded-5 mb-20">
                  <span className="ail-gd-bg"></span>Integration
                </p>
                <h2 className="ail-title text-black fs-48 fw-600">
                  Powerful application with{" "}
                  <span className="ail-highlighted-text">
                    seamless integration
                  </span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <img
                src="assets/img/ail_home/intg.png"
                alt=""
                className="w-100 img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentGeneratorIntegration;
